// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dimensions-measure-OjV {\n    flex-basis: 50%;\n}\n\n.dimensions-value-5A9 {\n    flex-basis: 50%;\n}\n\n.dimensions-pdfMeasure-zhk {\n    font-weight: normal !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"measure": "dimensions-measure-OjV font-bold",
	"value": "dimensions-value-5A9 text-bronze",
	"pdfMeasure": "dimensions-pdfMeasure-zhk"
};
export default ___CSS_LOADER_EXPORT___;
